<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ActionForm from './ActionForm.vue';

const props = defineProps({
  action: { type: Object, default: null },
});

const emit = defineEmits(['close']);

const store = useStore();
const dialogRef = ref(null);

const handleSubmit = async formData => {
  try {
    if (props.action) {
      await store.dispatch('voiceAgentActions/update', {
        id: props.action.id,
        ...formData,
      });
      useAlert('Action updated successfully');
    } else {
      await store.dispatch('voiceAgentActions/create', formData);
      useAlert('Action created successfully');
    }
    dialogRef.value.close();
    emit('close');
  } catch (error) {
    useAlert(error.message || 'Failed to save action');
  }
};

const handleCancel = () => {
  dialogRef.value.close();
  emit('close');
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="
      action
        ? $t('AI_VOICE.ACTIONS.EDIT_TITLE')
        : $t('AI_VOICE.ACTIONS.CREATE_TITLE')
    "
    :show-cancel-button="false"
    :show-confirm-button="false"
    width="2xl"
    overflow-y-auto
  >
    <ActionForm
      :action="action"
      @submit="handleSubmit"
      @cancel="handleCancel"
    />
    <template #footer />
  </Dialog>
</template>
